import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/createSuper";
var _excluded = ["active", "className", "disabled", "readOnly", "error", "values", "placeholder", "variant", "isField", "popoverIcon"];
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import * as React from 'react';
import clsx from 'clsx';
var styles = {
  "root": "Select-root_1tCgo",
  "small": "Select-small_3Poor",
  "is-disabled": "Select-is-disabled_tqx0q",
  "is-active": "Select-is-active_2YQ85",
  "is-readOnly": "Select-is-readOnly_3WbSG",
  "has-error": "Select-has-error_WZsGV",
  "block": "Select-block_1TOe-"
};
var Select = /*#__PURE__*/function (_React$Component) {
  _inherits(Select, _React$Component);
  var _super = _createSuper(Select);
  function Select() {
    var _this;
    _classCallCheck(this, Select);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.renderItem = function (item, index) {
      if ('value' in item && !Array.isArray(item.value) && !Array.isArray(item.text)) {
        return /*#__PURE__*/React.createElement("option", {
          key: "key-".concat(item.value, "-").concat(index),
          value: item.value
        }, item.text);
      }
      return _Object$keys(item).map(function (label) {
        return Array.isArray(item[label]) ? /*#__PURE__*/React.createElement("optgroup", {
          key: label,
          label: label
        }, item[label].map(_this.renderItem)) : null;
      });
    };
    _this.oldValueExist = function (item) {
      var value = _this.props.value;
      if ('value' in item) {
        return item.value === value;
      }
      return _Object$keys(item).some(function (key) {
        return Array.isArray(item[key]) ? item[key].some(_this.oldValueExist) : false;
      });
    };
    return _this;
  }
  _createClass(Select, [{
    key: "render",
    value: function render() {
      var _clsx;
      var _this$props = this.props,
        active = _this$props.active,
        className = _this$props.className,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        error = _this$props.error,
        values = _this$props.values,
        placeholder = _this$props.placeholder,
        variant = _this$props.variant,
        isField = _this$props.isField,
        popoverIcon = _this$props.popoverIcon,
        inputProps = _objectWithoutProperties(_this$props, _excluded);
      var selectClassName = clsx(styles.root, className, (_clsx = {
        'is-active': active
      }, _defineProperty(_clsx, styles.block, variant.indexOf('block') > -1), _defineProperty(_clsx, styles['is-disabled'], disabled), _defineProperty(_clsx, styles['is-readOnly'], readOnly), _defineProperty(_clsx, styles['has-error'], error), _defineProperty(_clsx, 'has-error', error), _defineProperty(_clsx, styles.small, variant.indexOf('small') > -1), _clsx));
      var invalidValue = !values.some(this.oldValueExist);
      return (
        /*#__PURE__*/
        // $FlowFixMe[cannot-spread-inexact]
        React.createElement("select", _extends({
          className: selectClassName,
          disabled: disabled,
          "aria-readonly": readOnly
        }, inputProps), placeholder && /*#__PURE__*/React.createElement("option", {
          className: styles.placeholder,
          value: ""
          // $FlowFixMe[prop-missing]
          ,
          disabled: inputProps.required && !invalidValue
        }, placeholder), values.map(this.renderItem))
      );
    }
  }]);
  return Select;
}(React.Component);
Select.defaultProps = {
  active: false,
  disabled: false,
  readOnly: false,
  variant: ['default'],
  error: ''
};
export { Select as default };